import Util from "./js/util.js";
import { consistencyCheck } from '../api/index.js';
// import seting from '../../public/seting.js';

//这个函数在整个wps加载项中是第一个执行的
function OnAddinLoad(ribbonUI) {
  if(!setingDefault.remember) {
    localStorage.clear();
  }
  if(localStorage.wps) {
    const user = JSON.parse(localStorage.wps);
    wps.PluginStorage.setItem('token', user.token || '');
  }
  if (typeof wps.ribbonUI != "object") {
    wps.ribbonUI = ribbonUI;
  }
  if (typeof wps.Enum != "object") {
    // 如果没有内置枚举值
    wps.Enum = Util.WPS_Enum;
  }

  wps.PluginStorage.setItem("isContinue", true); // 上次校对默认没有被中断过
  wps.PluginStorage.setItem("checkBoxErr", '');

  AddDocumentEvent();
  return true;
}

// 配置初始化
function initSetting () {
  const {
    colorMode,
    errorcolor,
    warningColor,
    sensitiveColor,
    radio,
    proofreading,
    export_scope,
  } = setingDefault;

  const defaultTextStyle = {
    type: colorMode,
    error: errorcolor,
    sensitive: sensitiveColor,
    warning: warningColor,
  }
  // 校验初始化
  localStorage.setItem('errorStatistics', JSON.stringify({
    list: [],
  }))
  localStorage.setItem('checkList', JSON.stringify(export_scope));
  localStorage.setItem('textStyle', JSON.stringify(defaultTextStyle));

  wps.PluginStorage.setItem("login", true); // 未登录
  wps.PluginStorage.setItem("loggedIn", false); // 已登录

  localStorage.setItem('radio', radio);
  localStorage.setItem('proofreading', proofreading);
  wps.PluginStorage.setItem("isContinue", true); // 上次校对默认没有被中断过
  wps.PluginStorage.setItem("checkBoxErr", '');
}

// 批处理默认值
function OnCheckBoxAction() {
  const state = setingDefault.checkBox;
  const locState = localStorage.getItem('checkBox');

  localStorage.setItem('checkBox', locState || state);
  return localStorage.getItem('checkBox')
}

// 点击
function OnAction(control) {
  console.log(control)
  if(typeof(control) == "boolean") {
    console.log('shawanyier')
    localStorage.setItem('checkBox', control)
  }
  const eleId = control.Id;
  const selection = wps.Application.Selection.Text;
  const radio_ = localStorage.getItem("radio");
  const user = localStorage.wps ? JSON.parse(localStorage.wps) : '';
  // 校验错误列表
  const { domains, errorStatistics } = localStorage;
  let errors, errorList
  if(errorStatistics) {
    errors = JSON.parse(errorStatistics);
    errorList = errors.list;
  }

  switch (eleId) {
    case "login":
      wps.ShowDialog(
        Util.GetUrlPath() + "login",
        "登录",
        400 * window.devicePixelRatio,
        400 * window.devicePixelRatio,
        true
      );
      break;
    case 'translation':
      wps.OAAssist.ShellExecute(setingDefault.translation + selection );
      break;
    case 'statute':
      wps.OAAssist.ShellExecute(setingDefault.statute + selection +"&Sort=PublishTime&Type=1");
      break;
    // 术语查询
    case 'term':
      wps.OAAssist.ShellExecute(setingDefault.term + selection);
      break;
    case 'about1':
      wps.OAAssist.ShellExecute(setingDefault.web_site || 'http://crm.yiyiaitech.com:8080/download/');
      break;
    case 'about2':
      const v = setingDefault.version || wps.Version;
      alert("版本号： " + v)
      // MessageBox(0, '您点击了按“测试功能”！', '提示', MB_OK + MB_ICONINFORMATION)
      break;
    // 账号信息
    case 'username':
      alert("当前账号： " + user.user.userid)
      break;
    // 专业校对
    case 'radio1':
      localStorage.setItem('radio', 'radio1');
      wps.ribbonUI.Invalidate();
      break;
    // 综合校对
    case 'radio2':
      localStorage.setItem('radio', 'radio2');
      wps.ribbonUI.Invalidate();
      break;
    // 文本领域
    case 'textField':
      wps.ShowDialog(
        Util.GetUrlPath() + "textFieldDialog",
        "文本领域",
        400 * window.devicePixelRatio,
        600 * window.devicePixelRatio,
        false,
      );
      break;
    // 通篇校对
    case 'textProofreading':
      const isContinue  = wps.PluginStorage.getItem("isContinue");

      if(!isContinue) {
        const setState = wps.confirm('检查到本文章上次校对没有完成，是否继续上次校对？(点击"确定"继续上次校对, 点击"取消"重新开始校对)');
        wps.PluginStorage.setItem("isContinue", true);
        if(!setState) {
          localStorage.setItem("breakLine", "");
          clearAll();
          wps.ShowDialog(
            Util.GetUrlPath() + "textProofreading",
            "通篇校对",
            300 * window.devicePixelRatio,
            250 * window.devicePixelRatio,
            false
          );
        } else {
          wps.ShowDialog(
            Util.GetUrlPath() + "textProofreading",
            "通篇校对",
            300 * window.devicePixelRatio,
            250 * window.devicePixelRatio,
            false
          );
        }
      } else {
        if(domains || radio_ === 'radio2') {
          clearAll();
          wps.ShowDialog(
            Util.GetUrlPath() + "textProofreading",
            "通篇校对",
            300 * window.devicePixelRatio,
            250 * window.devicePixelRatio,
            false
          );
        } else {
          alert('您还没有设置科学领域，这将降低检测效果请先选择本篇文章的文本领域！');
          wps.ShowDialog(
            Util.GetUrlPath() + "textFieldDialog",
            "文本领域",
            400 * window.devicePixelRatio,
            600 * window.devicePixelRatio,
            true,
          );
        }
      }
      break;
    // 清除全部标记
    case 'clearAll':
      clearAll();
      localStorage.setItem('errorStatistics', JSON.stringify({
        list: [],
      }))
      break;
    // 一致性检查
    case 'consistency':
      clearAll();
      localStorage.setItem('errorStatistics', JSON.stringify({
        list: [],
      }));
      OnConsistencyCheck();
      break;
    // 清除当前标记
    case 'clearMark':
      wps.PluginStorage.setItem("isUpdateDialog", false); //是否显示修改弹窗
      let list_ = errorList;
      let selectionOBJ = wps.Application.ActiveDocument.ActiveWindow.Selection;
      const selectionText = selectionOBJ.Text;
      const selectionStart = selectionOBJ.Start;

      if(selectionText) {
        list_.forEach((i, dex) => {
          if(selectionStart >= i.start && i.end > selectionStart) {
            const actionObj = Application.ActiveDocument.Range(i.start, i.end);
            actionObj.HighlightColorIndex = 0;
            actionObj.Font.ColorIndex = 0;
            list_.splice(dex, 1);
          }
          localStorage.setItem('errorStatistics', JSON.stringify({
            list: list_,
          }));
        });
      }
      break;
    case 'logout':
      const setUser = {
        pwd: user.user.pwd,
        userid: user.user.userid,
      };
      localStorage.clear();
      wps.ribbonUI.Invalidate();
      if(setingDefault.remember) {
        localStorage.setItem('user', JSON.stringify(setUser))
      }
      break;
    case 'pie':
      wps.ShowDialog(
        Util.GetUrlPath() + "pie",
        "饼状表",
        1000 * window.devicePixelRatio,
        700 * window.devicePixelRatio,
        false
      );
      break;
    // 正词库
    case 'thesaurus':
      wps.ShowDialog(
        Util.GetUrlPath() + "thesaurus",
        "正词词典",
        800 * window.devicePixelRatio,
        600 * window.devicePixelRatio,
        false
      );
    break;
    // 错词库
    case 'wrongThesaurus':
      wps.ShowDialog(
        Util.GetUrlPath() + "wrongThesaurus",
        "错词库",
        700 * window.devicePixelRatio,
        600 * window.devicePixelRatio,
        false
      );
    break;
    // 重点监控
    case 'monitor':
      wps.ShowDialog(
        Util.GetUrlPath() + "monitor",
        "重点监控",
        700 * window.devicePixelRatio,
        600 * window.devicePixelRatio,
        false
      );
    break;
    // 当前段落
    case 'currentParagraph':
      if(domains || radio_ === 'radio2') {
        clearAll();
        wps.ShowDialog(
          Util.GetUrlPath() + "currentParagraph",
          "当前段落",
          300 * window.devicePixelRatio,
          250 * window.devicePixelRatio,
          false,
        );
      } else {
        alert('您还没有设置科学领域，这将降低检测效果请先选择本篇文章的文本领域！');
        wps.ShowDialog(
          Util.GetUrlPath() + "textFieldDialog",
          "文本领域",
          400 * window.devicePixelRatio,
          600 * window.devicePixelRatio,
          true,
        );
      }
      break;
    // 标记方式
    case 'markingStyle':
      wps.ShowDialog(
        Util.GetUrlPath() + "markingStyle",
        "高级设置",
        600 * window.devicePixelRatio,
        500 * window.devicePixelRatio,
        false
      );
      break;
    // 文献生成
    case 'literature':
      wps.OAAssist.ShellExecute("https://xueshu.baidu.com/s?wd=" + selection);
      // wps.ShowDialog(
      //   Util.GetUrlPath() + "literature",
      //   "参考文献查询",
      //   500 * window.devicePixelRatio,
      //   500 * window.devicePixelRatio,
      //   true
      // );
      break;
    // 勘误表
    case 'errata':
      wps.ShowDialog(
        Util.GetUrlPath() + "errata",
        "勘误表",
        500 * window.devicePixelRatio,
        500 * window.devicePixelRatio,
        true
      );
    break;
    // 辞书查词
    case 'dictionary':
      wps.ShowDialog(
        Util.GetUrlPath() + "dictionary",
        "辞书查词",
        500 * window.devicePixelRatio,
        500 * window.devicePixelRatio,
        false
      );
    break;
    // 上一处
    case 'upError':
      const { Start } = wps.Application.ActiveDocument.ActiveWindow.Selection;
      const find = errorList.reduce((prev, curr) => {
        if(curr.start < Start) {
          prev.push(curr);
        }
        return prev;
      }, []);

      if(find.length > 0) {
        wps.Application.Selection.SetRange(find[find.length-1].start, find[find.length-1].end);
        wps.Application.ActiveDocument.ActiveWindow.Selection.Range.Select();
      }

    break;
    // 下一处错误
    case 'nextError':
      const errStart = wps.Application.ActiveDocument.ActiveWindow.Selection.End;
      for (let f = 0; f < errorList.length; f++) {
        const element = errorList[f];
        if(errStart <= element.start) {
          wps.Application.Selection.SetRange(errorList[f].start, errorList[f].end);
          wps.Application.ActiveDocument.ActiveWindow.Selection.Range.Select();
          break;
        }
      }
      break;
    case 'proofreading1':
      localStorage.setItem('proofreading', 1);
      wps.ribbonUI.Invalidate();
      break;
    case 'proofreading2':
      localStorage.setItem('proofreading', 2);
      wps.ribbonUI.Invalidate();
      break;
    default:
      break;
  }
  return true;
}

function GetImage(control) {
  const eleId = control.Id;
  const radio = localStorage.getItem("radio");
  const proofreading = localStorage.getItem("proofreading");

  switch (eleId) {
    case "login":
      return "images/login.svg";
    case "about":
      return "images/shuyutong.svg";
    case "about1":
      return "images/about1.svg";
    case "about2":
      return "images/about2.svg";
    case "dictionary":
      return "images/shuyutong.svg";
    case "consistency":
      return "images/consistency.svg";
    case 'radio1':
      return  radio == 'radio1' ? "images/radio.svg" : "images/radioFalse.svg";
    case 'radio2':
      return  radio == 'radio2' ? "images/radio.svg" : "images/radioFalse.svg";
    case 'proofreading1':
      return  proofreading == 1 ? "images/radio.svg" : "images/radioFalse.svg";
    case 'proofreading2':
      return  proofreading == 2 ? "images/radio.svg" : "images/radioFalse.svg";
    case 'textField':
      return "images/texts.svg";
    case 'textProofreading':
      return "images/tbjd.svg";
    case 'currentParagraph':
      return 'images/currentParagraph.svg';
    case 'upError':
      return 'images/upError.svg';
    case 'nextError':
      return 'images/nextError.svg';
    case 'clearMark':
      return 'images/clearMark.svg';
    case 'clearAll':
      return 'images/clearAll.svg';
    case 'errata':
      return 'images/errata.svg';
    case 'pie':
      return 'images/pie.svg';
    case 'thesaurus':
      return 'images/thesaurus.svg';
    case 'wrongThesaurus':
      return 'images/wrongThesaurus.svg';
    case 'monitor':
      return 'images/monitor.svg';
    case 'literature':
      return 'images/literature.svg';
    case 'term':
      return 'images/term.svg';
    case 'statute':
      return 'images/statute.svg';
    case 'translation':
      return 'images/translation.svg';
    case 'markingStyle':
      return 'images/markingStyle.svg';
    case 'logout':
      return 'images/logout.svg';
    case 'username':
      return 'images/username.svg';
    default:
  }
  return "images/newFromTemp.svg";
}

function handleLogin () {
  if(localStorage.wps) {
    const user = JSON.parse(localStorage.wps);
    if(user.token && wps.PluginStorage.getItem("loggedIn") && !wps.PluginStorage.getItem("login")) return;
    if(user.token) {
      wps.PluginStorage.setItem("login", false);
      wps.PluginStorage.setItem("loggedIn", true);
    } else {
      wps.PluginStorage.setItem("login", true);
      wps.PluginStorage.setItem("loggedIn", false);
    }
  } else {
    initSetting();
  }
  wps.ribbonUI.Invalidate();
}

function OnGetVisible(control) {

  handleLogin();
  const eleId = control.Id;

  const isLogin = wps.PluginStorage.getItem("loggedIn");
  const radio = localStorage.getItem("radio");

  if(eleId == 'login') {
    return wps.PluginStorage.getItem("login");
  }
  if(eleId == 'loggedIn') {
    return wps.PluginStorage.getItem("loggedIn");
  }

  const findId = seting.find(i => i.key === eleId) || undefined;


  if(eleId == 'logloggedInRadio1' && isLogin && radio == 'radio1') {
    return true;
  }

  if(eleId == 'logloggedInRadio2' && isLogin && radio == 'radio2') {
    return true;
  }

  if(eleId =='SetProofreading' && isLogin && radio == 'radio2') {
    return true;
  }

  if(findId && findId != undefined && isLogin || eleId == 'about1' || eleId == 'about2' || eleId == 'about' ) {
    return findId.show
  }

  return false;
}

//  清除所有标记
function clearAll() {
  wps.Application.ActiveDocument.Range().HighlightColorIndex = 0;
  wps.Application.ActiveDocument.Range().Font.ColorIndex = 0;
}

// 一致性检查
function OnConsistencyCheck() {
  const text = wps.Application.ActiveDocument.Range().Text;

  consistencyCheck({
    method: 'prr',
    text: text
  }).then((res = []) => {
    const textStyle = JSON.parse(localStorage.getItem('textStyle'));

    res.forEach((item) => {
      const { error_word } = item;

      for(var i = -1; (i = text.indexOf(error_word, i + 1)) >= 0;) {
        console.log(textStyle)
        if(textStyle && textStyle.type == 'font') {
          wps.Application.ActiveDocument.Range(i, i + error_word.length).Font.ColorIndex = textStyle.error;
        }else {
          wps.Application.ActiveDocument.Range(i, i + error_word.length).HighlightColorIndex = textStyle ? textStyle.error : 6;
        }
      }
    });
  });
}

// 绑定事件
function AddDocumentEvent() {
  wps.ApiEvent.AddApiEventListener("WindowSelectionChange", OnWindowSelectionChange);
  console.log("AddDocumentEvent");
}

function showLoading(url) {
  wps.PluginStorage.setItem("commonShowDialog", true);
  wps.ShowDialog(
    url,
    "修改",
    400 * window.devicePixelRatio,
    600 * window.devicePixelRatio,
    true,
  );
}

function hideLoading() {
  wps.PluginStorage.setItem("commonShowDialog", false);
}

// 编辑区所选内容更改时
function OnWindowSelectionChange(e) {
  const isUpdateDialog = wps.PluginStorage.getItem("isUpdateDialog");
  hideLoading();
  wps.PluginStorage.setItem("commonShowDialog", false);
  const { Start, End, Text } = e;
  let location = wps.Application.ActiveDocument.Range(Start, End+1);
  const HighlightColor = location.HighlightColorIndex
  const FontColor = location.Font.ColorIndex

  if(HighlightColor && isUpdateDialog || FontColor && isUpdateDialog) {
      const { errorStatistics } = localStorage;
      const { list = [] } = JSON.parse(errorStatistics);
      try {
        list.forEach((i) => {
          const { error_word, start, end } = i;
          if(error_word.indexOf(Text) >= 0 && Start >= start && end > Start) {
            showLoading(
              Util.GetUrlPath() + 'updateAdvice?item=' + JSON.stringify({
                ...i,
                change: true
              }),
            )
            throw('循环终止')
          }
        });
      } catch(e) {
        console.log('e: ', e, )
      }
  }

  wps.PluginStorage.setItem("isUpdateDialog", true);
}

//这些函数是给wps客户端调用的
export default {
  OnAddinLoad,
  OnAction,
  GetImage,
  OnGetVisible,
  OnCheckBoxAction,
};
